// NOTE: Use capacitor-firebase plugin when database plugin is published
// https://github.com/capawesome-team/capacitor-firebase

import { Capacitor } from '@capacitor/core';
import { initializeApp } from '@firebase/app';
import { getAuth, indexedDBLocalPersistence, initializeAuth } from '@firebase/auth';
import type { Auth } from '@firebase/auth';
import { getDatabase } from '@firebase/database';

import { captureException } from '@skippay/core/global/errorTracking';

const firebase = initializeApp({
	apiKey: process.env.PUBLIC_FIREBASE_API_KEY,
	authDomain: process.env.PUBLIC_FIREBASE_AUTH_DOMAIN,
	projectId: process.env.PUBLIC_FIREBASE_PROJECT_ID,
	measurementId: process.env.PUBLIC_FIREBASE_MEASUREMENT_ID,
	databaseURL: process.env.PUBLIC_FIREBASE_DATABASE_URL,
});

const getFirebaseAuth = async (): Promise<Auth> => {
	if (Capacitor.isNativePlatform()) {
		return initializeAuth(firebase, {
			persistence: indexedDBLocalPersistence,
		});
	}

	return getAuth(firebase);
};

const database = getDatabase(firebase);

// eslint-disable-next-line import/no-mutable-exports
let auth: Auth | null = null;

async function initFirebase() {
	try {
		auth = await getFirebaseAuth();
	} catch (error) {
		captureException(new Error('Firebase auth initialization failed'), {
			extra: {
				originalError: error,
			},
		});
	}
}

initFirebase();

export { firebase, database, auth };
